module.exports = __webpack_public_path__ + "img/syukyaku-top-001sp.c4f6131d.jpg";